import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f74cd6b2")

_pushScopeId("data-v-f74cd6b2")
const _hoisted_1 = { class: "CompletedServices" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "CompletedServices__header" }, [
  /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "Доп. услуги")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "CompletedServices__body"
}
const _hoisted_4 = { class: "body__row" }
const _hoisted_5 = {
  key: 0,
  class: "col__text"
}
const _hoisted_6 = {
  key: 1,
  class: "col__text"
}
const _hoisted_7 = {
  key: 2,
  class: "col__text"
}
const _hoisted_8 = {
  key: 0,
  class: "col__text"
}
const _hoisted_9 = {
  key: 1,
  class: "col__text"
}
const _hoisted_10 = {
  key: 2,
  class: "col__text"
}
const _hoisted_11 = {
  key: 3,
  class: "col__text"
}
const _hoisted_12 = {
  key: 4,
  class: "col__text"
}
const _hoisted_13 = {
  key: 0,
  class: "CompletedServices__body__item"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Обрешетка ")
const _hoisted_15 = {
  key: 0,
  class: "CompletedServices__body__item"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_18 = {
  key: 1,
  class: "CompletedServices__body__item"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Паллета ")
const _hoisted_20 = {
  key: 0,
  class: "CompletedServices__body__item"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_23 = {
  key: 2,
  class: "CompletedServices__body__item"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Мягкая упаковка ")
const _hoisted_25 = {
  key: 0,
  class: "CompletedServices__body__item"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("sup", null, "3", -1)
const _hoisted_28 = {
  key: 3,
  class: "CompletedServices__body__item"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Рохля ")
const _hoisted_30 = {
  key: 0,
  class: "CompletedServices__body__item"
}
const _hoisted_31 = {
  key: 4,
  class: "CompletedServices__body__item"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Грузчики ")
const _hoisted_33 = {
  key: 0,
  class: "CompletedServices__body__item"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.additionalServices)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.additionalServices.hasCar)
              ? (_openBlock(), _createBlock("p", _hoisted_5, "Авто"))
              : _createCommentVNode("", true),
            (_ctx.additionalServices.hasManipulator)
              ? (_openBlock(), _createBlock("p", _hoisted_6, "Манипулятор"))
              : _createCommentVNode("", true),
            (_ctx.additionalServices.hasCrane)
              ? (_openBlock(), _createBlock("p", _hoisted_7, "Кран"))
              : _createCommentVNode("", true),
            (!_ctx.additionalServicesBilling.length)
              ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                  (_ctx.additionalServices.hasSoftPackage)
                    ? (_openBlock(), _createBlock("p", _hoisted_8, " Мягкая упаковка "))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasHydraulicTrolley)
                    ? (_openBlock(), _createBlock("p", _hoisted_9, "Рохля"))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasGrid)
                    ? (_openBlock(), _createBlock("p", _hoisted_10, "Обрешетка"))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasLoader)
                    ? (_openBlock(), _createBlock("p", _hoisted_11, "Грузчики"))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasPallet)
                    ? (_openBlock(), _createBlock("p", _hoisted_12, "Паллета"))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                  (_ctx.additionalServices.hasGrid)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _hoisted_14,
                        (_ctx.additionalServicesBilling.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_15, [
                              _createVNode("span", null, [
                                _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('grid', 'minValue')) + " м", 1),
                                _hoisted_16
                              ]),
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.getValue('grid', 'price')) + " тг/м", 1),
                                _hoisted_17
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasPallet)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _hoisted_19,
                        (_ctx.additionalServicesBilling.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_20, [
                              _createVNode("span", null, [
                                _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('pallet', 'minValue')) + " м", 1),
                                _hoisted_21
                              ]),
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.getValue('pallet', 'price')) + " тг/м", 1),
                                _hoisted_22
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasSoftPackage)
                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                        _hoisted_24,
                        (_ctx.additionalServicesBilling.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_25, [
                              _createVNode("span", null, [
                                _createTextVNode(" Мин. " + _toDisplayString(_ctx.getValue('soft_package', 'minValue')) + " м", 1),
                                _hoisted_26
                              ]),
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.getValue('soft_package', 'price')) + " тг/м", 1),
                                _hoisted_27
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasHydraulicTrolley)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _hoisted_29,
                        (_ctx.additionalServicesBilling.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_30, [
                              _createVNode("span", null, " Мин. " + _toDisplayString(_ctx.getValue('hydraulic_trolley', 'minValue')) + " часа ", 1),
                              _createVNode("span", null, _toDisplayString(_ctx.getValue('hydraulic_trolley', 'price')) + " тг/час", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.additionalServices.hasLoader)
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        _hoisted_32,
                        (_ctx.additionalServicesBilling.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_33, [
                              _createVNode("span", null, " Мин. " + _toDisplayString(_ctx.getValue('loader', 'minValue')) + " часа ", 1),
                              _createVNode("span", null, _toDisplayString(_ctx.getValue('loader', 'price')) + " тг/час", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})